import React from 'react';
import Woman_Yoga from '../assests/woman-yoga.jpg';
import Woman_Cardio from '../assests/woman-cardio.webp';
import Man_Crossfit from '../assests/man-crossfit.jpg';
import Man_Strength from '../assests/man-strength.jpg';

const Card = ({ title, instructor, time, image }) => {

  const pageHandler =()=> {
    window.location.href = "/contact";
  }
    return (
        <div className="class-card" style={{ backgroundImage: `url(${image})` }}>
            <div className="class-card-content">
                <h3 className='class-card-title'>{title}</h3>
                <div className="class-card-info">
                    <div className="class-card-column">
                        <i className="fas fa-user"></i> {instructor}
                    </div>
                    <div className="class-card-column">
                        <i className="fas fa-clock"></i> {time}
                    </div>
                </div>
                <button className="class-card-button" onClick={pageHandler}>JOIN NOW</button>
            </div>
        </div>
    );
};

const HomeClasses = () => {

  const classes = [
    { title: 'Yoga', instructor: 'Jane Doe', time: 'Mon: 8:00 am', image: Woman_Yoga },
    { title: 'Cardio', instructor: 'Linda White', time: 'Thu: 7:00 am', image: Woman_Cardio },
    { title: 'Strength', instructor: 'David Brown', time: 'Sat: 10:00 am', image: Man_Strength },
    { title: 'Crossfit', instructor: 'Mike Johnson', time: 'Fri: 6:00 pm', image: Man_Crossfit },
];

const pageChangeer =()=>{
  window.location.href = "/classes";
}

  return (
  <section className="home-classes-section">
    <div className="home-classes-container">
      <div className="home-header-container">
        <h1 className="home-classes-heading">Our Classes</h1>
      </div>
      <div className="class-cards-container">
      {classes.map((classInfo, index) => (
        <Card
        key={index}
        title={classInfo.title}
        instructor={classInfo.instructor}
        time={classInfo.time}
        image={classInfo.image}
        />
      ))}
      </div>
    </div>
    <button className="home-more-button" onClick={pageChangeer}>More</button>
</section>

  )
}

export default HomeClasses;